import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

import { CookieService } from 'ngx-cookie-service';

import { UserHttpService } from './user-http.service';

import { VideoService } from './video.service';

import { CurrentUser } from '@core/models/current-user';
import { LoginResponse } from '@core/models/login-response';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	private currentUser: CurrentUser | null;
	private token: string;
	private userDataRetrieved: boolean;

	constructor(@Inject(DOCUMENT) private document: Document,
		private cookieService: CookieService,
		private videoService: VideoService,
		private userHttpService: UserHttpService) {

		this.currentUser = null;
		this.token = cookieService.get('kwo_auth');
		this.userDataRetrieved = false;
	}

	public setToken(token: string) {

		this.token = token;
	}

	public getToken(): string {

		return this.token;
	}

	public validateToken(): Observable<boolean> {

		if (!this.token) {

			return of(false);
		}

		return this.userHttpService.validateToken().pipe(
			map((response: LoginResponse) => {

				if (!response.subscription.active) {

					this.reset();
					return false;
				}

				this.setUser(response);

				if (!this.userDataRetrieved) {

					this.videoService.getWatched();
					this.videoService.getKeepWatching();
					this.videoService.getRecommendations();

					this.userDataRetrieved = true;
				}

				return true;
			}),
			catchError((err: any) => {

				this.reset();

				return of(false);
			})
		);
	}

	public setUser(response: LoginResponse) {

		const currentUser = new CurrentUser();
		currentUser.profileImage = response.user.profile_image;
		currentUser.firstName = response.user.first_name;
		currentUser.lastName = response.user.last_name;
		currentUser.name = response.user.name;
		currentUser.email = response.user.email;
		currentUser.has_open_payments = response.user.has_open_payments;
		currentUser.payment_uri = response.user.payment_uri;
		currentUser.subscription = response.subscription;
		currentUser.subscription_addons = response.subscription_addons;

		this.currentUser = currentUser;
	}

	getUser(): CurrentUser | null {

		return this.currentUser;
	}

	public reset() {

		let domain = this.document.location.hostname.replace('community', '');
		this.cookieService.delete('kwo_auth', '/', domain);

		this.currentUser = null;
		this.token = '';
		this.userDataRetrieved = false;
	}

	public updateUserProfile(userProfile: any) {

		return new Promise((resolve, reject) => {

			this.userHttpService.updateUserProfile(userProfile)
				.subscribe({
					next: (response: any) => {

						this.currentUser!.firstName = userProfile.first_name;
						this.currentUser!.lastName = userProfile.last_name;

						resolve(response);
					},
					error: (err: any) => {

						reject(err);
					}
				});
		});
	}

	public updateUserPassword(params: any) {

		return this.userHttpService.updateUserPassword(params);
	}

	public updateUserProfileImage(params: any) {

		return this.userHttpService.updateUserProfileImage(params);
	}

	public getAddOnQuoteForUser(addOn: string) {

		return this.userHttpService.getAddOnQuoteForUser(addOn);
	}

	public activateAddOn(addOn: string) {

		return this.userHttpService.activateAddOn(addOn);
	}

	public deactivateAddOn(addOn: string) {

		return this.userHttpService.deactivateAddOn(addOn);
	}
}